import * as React from 'react'
import 'react-date-range/dist/styles.css'
import 'react-date-range/dist/theme/default.css'
import {DateRangePicker as DateRangePickerLib} from 'react-date-range'
import PopupState, {bindMenu, bindTrigger} from 'material-ui-popup-state'
import {Button, IconButton, InputAdornment, Popover, TextField} from '@mui/material'
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth'
// import { addDays } from 'date-fns/esm';
import {Box} from '@mui/system'
import CheckIcon from '@mui/icons-material/Check'
import {formatDate} from '../helpers/UtilityHelper'

export default function DateRangePicker(props) {
  // const { onChange, defaultRange, showTextBox = false, ...other } = props
  const {
    onChange,
    defaultRange,
    showTextBox = false,
    limitToOneMonth = false,
    btnColor = 'button',
    triggerVariant = 'contained',
    triggerSx = {},
    ...other
  } = props

  let defaultDateRange = [
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]

  if (defaultRange && defaultRange.length > 0) {
    defaultDateRange = defaultRange
  }

  const [dateRange, setDateRange] = React.useState(defaultDateRange)
  //     const handleDateRangeChange = (dates) => {
  //     let maxDate = props.maxDate
  //     // Ensure that the selected start date does not exceed maxDate
  //     if (maxDate && dates.selection.startDate > maxDate) {
  //         dates.selection.startDate = maxDate;
  //     }

  //     // Ensure that the selected end date does not exceed maxDate
  //     if (maxDate && dates.selection.endDate > maxDate) {
  //         dates.selection.endDate = maxDate;
  //     }

  //     setDateRange([dates.selection]);
  // };
  const handleDateRangeChange = (dates) => {
    let maxDate = props.maxDate
    const startDate = dates.selection.startDate
    const endDate = dates.selection.endDate

    if (limitToOneMonth && startDate) {
      // Calculate one month from start date
      const oneMonthFromStart = new Date(startDate)
      oneMonthFromStart.setMonth(oneMonthFromStart.getMonth() + 1)
      oneMonthFromStart.setDate(oneMonthFromStart.getDate() - 1)

      // If end date is more than one month from start date, adjust it
      if (endDate > oneMonthFromStart) {
        dates.selection.endDate = oneMonthFromStart
      }
    }

    // Existing maxDate checks
    if (maxDate && dates.selection.startDate > maxDate) {
      dates.selection.startDate = maxDate
    }
    if (maxDate && dates.selection.endDate > maxDate) {
      dates.selection.endDate = maxDate
    }

    setDateRange([dates.selection])
  }

  React.useEffect(() => {
    if (defaultRange?.length > 0) {
      setDateRange(defaultRange)
    }
  }, [defaultRange])

  let val = ''
  if (dateRange.length > 0) {
    // val = `${formatDate(dateRange[0].startDate, 'dd MMM yyyy')
    //     } - ${formatDate(dateRange[0].endDate, 'dd MMM yyyy')
    //     }`
    if (dateRange[0]?.startDate) {
      val += formatDate(dateRange[0]?.startDate, 'dd MMM yyyy')
    }

    if (dateRange[0]?.endDate) {
      val += '-' + formatDate(dateRange[0]?.endDate, 'dd MMM yyyy')
    }
  }

  React.useEffect(() => {
    if (defaultRange?.length > 0) {
      setDateRange(defaultRange)
    } else {
      setDateRange([{startDate: null, endDate: null, key: 'selection'}]) // Reset when cleared
    }
  }, [defaultRange])

  const disableDates = (date) => {
    if (!limitToOneMonth) return false
    if (!dateRange[0]?.startDate) return false

    // Calculate one month from start date
    const oneMonthFromStart = new Date(dateRange[0].startDate)
    oneMonthFromStart.setMonth(oneMonthFromStart.getMonth() + 1)
    oneMonthFromStart.setDate(oneMonthFromStart.getDate() - 1)

    // Disable dates after one month from start date
    return date > oneMonthFromStart
  }

  return (
    <PopupState variant='popover' popupId='date-range-selector'>
      {(popupState) => (
        <React.Fragment>
          {showTextBox ? (
            <TextField
              onClick={popupState.open}
              readOnly={true}
              value={val}
              variant='outlined'
              size='small'
              sx={{width: '100%'}}
              label={props.label ? props.label : 'Select Range'}
              InputLabelProps={{
                sx: {
                  fontSize: 10,
                  '&:not(.MuiInputLabel-shrink)': {
                    transform: 'translate(14px, 12px) scale(1)',
                  },
                },
              }}
              InputProps={{
                sx: { fontSize: 12 },
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton size='small' {...bindTrigger(popupState)}>
                      <CalendarMonthIcon sx={{ fontSize: 18 }} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          ) : (
            <Button
              size='medium'
              variant={triggerVariant}
              color={btnColor}
              endIcon={<CalendarMonthIcon />}
              {...bindTrigger(popupState)}
              disableElevation
              sx={{boxShadow: 'none', ...triggerSx}}
            >
              {val}
            </Button>
          )}
          <Popover {...bindMenu(popupState)}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                justifyContent: 'space-between',
              }}
            >
              <DateRangePickerLib
                showSelectionPreview={true}
                moveRangeOnFirstSelection={false}
                months={2}
                direction='horizontal'
                ranges={dateRange}
                maxDate={props.maxDate ? props.maxDate : ''}
                disabledDay={disableDates}
                onChange={handleDateRangeChange}
                dateDisplayFormat='MMM d, yyyy'
                {...other}
              />

              <Button
                onClick={() => {
                  if (onChange instanceof Function) {
                    onChange(dateRange)
                  }
                  popupState.close()
                }}
                sx={{m: 2}}
                startIcon={<CheckIcon />}
                variant='contained'
                color='primary'
              >
                OK
              </Button>
            </Box>
          </Popover>
        </React.Fragment>
      )}
    </PopupState>
  )
}
